<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        center
        top="3%"
        width="52%">
        <div class="flex flex-direction padding-lr-xs" style="height: 70vh;overflow: auto">
            <div class="text-xxl line-height text-bold text-black text-center">会议记录</div>
            <table class="margin-top-sm" cellspacing="0" width="100%">
                <tbody class="">
                <tr>
                    <td class="text-black text-df text-bold text-center">会议名称</td>
                    <td class="text-black text-df text-center" colspan="5">{{ detail.title }}</td>
                </tr>
                <tr>
                    <td class="text-black text-df text-bold text-center">时间</td>
                    <td class="text-black text-df text-center">{{ detail.meeting_time }}</td>
                    <td class="text-black text-df text-bold text-center">地点</td>
                    <td class="text-black text-df text-center" colspan="3">{{ detail.address }}</td>
                </tr>
                <tr>
                    <td class="text-black text-df text-bold text-center">主持单位</td>
                    <td class="text-black text-df text-center">{{ detail.sponsor }}</td>
                    <td class="text-black text-df text-bold text-center">主持人</td>
                    <td class="text-black text-df text-center">{{ detail.emcee }}</td>
                    <td class="text-black text-df text-bold text-center">记录人</td>
                    <td class="text-black text-df text-center">{{ detail.note_taker }}</td>
                </tr>
                <tr>
                    <td class="text-black text-df text-bold text-center">参加人</td>
                    <td class="text-black text-df" colspan="5">{{ detail.participant }}</td>
                </tr>
                <tr>
                    <td class="text-black text-df text-bold text-center">缺席人员及原因</td>
                    <td class="text-black text-df text-center" colspan="5">{{ detail.absent_remark || '无' }}</td>
                </tr>
                <tr>
                    <td class="text-black text-df text-bold text-center" colspan="6">会议内容</td>
                </tr>
                <tr>
                    <td class="text-black text-df" colspan="6">
                        <div class="detail" v-html="detail.content"></div>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </el-dialog>
</template>

<script>


import {getMeetingDetail} from "@/api";

export default {
    name: "GroupMeetingDetailDialog",
    components: {},
    data() {
        return {
            detail: ''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        aid: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await getMeetingDetail(this.aid)
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        aid() {
            if (this.aid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    border-color: #333;
}

 td {
    width: 80px;
    padding: 20px 10px;
    font-size: 14px;
    border: 1px solid #333;
}
 thead td {
    padding: 15px 10px;
}
</style>